/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * Fires when an panel is clicked
 */
export interface PanelToggle {
  /**
   * Text within the panel in English.
   */
  panelName: string;
  /**
   * If true, the panel is open. If false, the panel is closed.
   */
  isOpen: boolean;
}

export const panelToggle = (data: Readonly<PanelToggle>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'panel_toggle', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/panel_toggle/jsonschema/1-0-1',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
